import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@chapche/ui';

const isMin = (fieldName: string) => {
    return fieldName.startsWith('min');
};

const PreferenceStructureNumberValue = ({field, preferenceStructureItem, handleUpdatePreferenceItem}) => {
    const { i18n } = useTranslation();
    const [numberValue, setNumberValue] = useState<number>(0);

    useEffect(() => {
        if (preferenceStructureItem && preferenceStructureItem[field]) {
            setNumberValue(preferenceStructureItem[field]);
        }
    }, [preferenceStructureItem]);

    const handleNumber = (e) => {
        const currentNumber = e.target.value;
        setNumberValue(currentNumber);
        handleUpdatePreferenceItem(field, currentNumber);
    };

    return (
        <label className="block__text product__form-label product__add-label">
            <span className="product__form-number product__form-label_text">{isMin(field) ? "Min" : "Max"} {i18n.t('product.scheme.property.code.valueOfData')}</span>
            <Input
                fullWidth
                className="mt-0"
                value={numberValue}
                onChange={handleNumber}
                name={field}
            />
        </label>
    );
};

export default PreferenceStructureNumberValue;
